import React from 'react';
import { compose } from 'redux';
import { Link, useParams } from 'react-router-dom';
import { ARRANGEMENT_TYPE_SLUG, CABINET_SLUG } from '../../../config';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';


const PurchasesArrangements = () => {
  let { lang } = useParams();
  return(
    <div>
      <p>
        { gettext('Для вашего удобства мы перенесли ваши покупки в раздел "Моя Коллекция".') }<br/>
        { gettext('Попасть туда можно перейдя по ссылке расположеной ниже.') }
      </p>
      <p><Link to={`/${lang}/${CABINET_SLUG}/collection/${ARRANGEMENT_TYPE_SLUG}/`}
               className={'font-weight-bold'}>{ gettext('Моя коллекция') }</Link></p>
    </div>
  )
}

export default compose(
  LoginRequired,
  Page,
)(PurchasesArrangements)
